var map = {
	"./center.svg": 3010,
	"./dl.svg": 2105,
	"./el-icon-error.svg": 5893,
	"./el-icon-success.svg": 5638,
	"./first.svg": 2245,
	"./first1.svg": 5326,
	"./left.svg": 1686,
	"./pwd.svg": 7942,
	"./right.svg": 5605,
	"./text.svg": 2948,
	"./title.svg": 129,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;